import { db } from '@/firebase/firebaseInit';
import { doc, query, collection, getDocs, updateDoc, increment, arrayUnion } from "firebase/firestore";

export default {
    async fetchSurveys(context) {
        const q = query(collection(db, "surveys"))
        const querySnapshot = await getDocs(q);

        if (querySnapshot.size == 0) {
            throw new Error("No Surveys found!");
        }

        const surveys = [];

        querySnapshot.forEach((doc) => {
            var survey = doc.data();
            survey.id = doc.id;
                if (survey.active == true) {
                context.commit('setActiveSurvey', survey);
            }
            surveys.push(survey);
        });
        context.commit('setSurveys', surveys);
    },

    async submitSurvey(context, payload) {

        const docRef = doc(db, "surveys/" + payload.surveyID);
        const beneficiaryID = payload.beneficiaryID;

        try {
            // Iterate over the itemLikesArray and dynamically update each item item
            await Promise.all(
                payload.itemLikesArray.map(async (item) => {
                 // Check if there are any likes or dislikes to process
                if (item.like > 0 || item.dislike > 0) {
                    // Prepare the dynamic update payload using FieldValue.increment for both likes and dislikes
                    const updateData = {};

                    // Increment the likes and add beneficiary ID to "who-like" if there are likes
                    if (item.like > 0) {
                    updateData[`${item.name}.like`] = increment(item.like); // Increment the likes
                    updateData[`${item.name}.who-like`] = arrayUnion(beneficiaryID); // Add beneficiary ID to "who-like"
                    }

                    // Increment the dislikes and add beneficiary ID to "who-dislike" if there are dislikes
                    if (item.dislike > 0) {
                    updateData[`${item.name}.dislike`] = increment(item.dislike); // Increment the dislikes
                    updateData[`${item.name}.who-dislike`] = arrayUnion(beneficiaryID); // Add beneficiary ID to "who-dislike"
                    }

                    // Record the entire submission under "submissions"
                    // updateData[`${item.name}.submissions`] = arrayUnion({ beneficiaryID, like: item.like, dislike: item.dislike });

                    // Update the Firebase document
                    await updateDoc(docRef, updateData);
        
                    console.log(`Successfully updated ${item.name} with ${item.like} likes, and ${item.dislike}.`);
                }
              })
            );
            console.log("All survey results successfully submitted to Firebase!");
          } catch (error) {
            console.error("Error updating document: ", error);
            throw new Error(error.message || 'Failed to fetch!');
          }
    }
}